module.exports = __webpack_public_path__ + "img/vnd-light.8338435b.png";